import React from 'react';
import { Modal } from 'react-bootstrap';
import './modal.scss';

interface LintLinkModalProps {
  id: string;
  show: boolean;
  onHide: () => void;
  title: React.ReactNode;
  className: string;
  body: React.ReactNode;
  size?: 'sm' | 'lg' | 'xl';
  fullscreen?: true | 'sm-down' | 'md-down' | 'lg-down' | 'xl-down' | 'xxl-down';
  footer?: React.ReactNode;
}

const LintLinkModal: React.FC<LintLinkModalProps> = ({
  id,
  show,
  onHide,
  className,
  title,
  body,
  size,
  fullscreen,
  footer,
}) => {
  return (
    <Modal
      id={id}
      className={className}
      show={show}
      onHide={onHide}
      size={size}
      fullscreen={fullscreen}
      centered
      backdrop='static'
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>{footer}</Modal.Footer>
    </Modal>
  );
};

export default LintLinkModal;
